import { CheckCircle } from "lucide-react";
import React, { useMemo } from "react";
import logoimg from "../../../assets/images/front/user01.webp";
import bannerimg from "../../../assets/image/headerBgJob.jpg";
import Button from "../../form/Button";
import Dropdown from "../../form/Dropdown";
import Tabs from "../../elements/Tabs";
import { useTabQuery } from "../../../hooks/useTabQuery";
import NotFoundPage from "../../common/NotFoundPage";
import CompanyHomeTab from "./CompanyHomeTab";
import CompanyAboutTab from "./CompanyAboutTab";
import CompanyJobsTab from "./CompanyJobsTab";
import Indentification from "../../elements/Indentification";

const CompanyTotalDetails = ({ organization }) => {
  const companyName = organization?.content?.en?.title;
  const description = organization?.content?.en?.content;
  const logo = organization?.logo?.url;
  const coverImage = organization?.coverImage?.url;
  const contactEmail = organization?.contactEmail;
  const createdAt = organization?.createdAt;
  const industry = organization?.businessInfo?.industry;
  const employeeCount = organization?.businessInfo?.employeeCount;
  const headquarter = organization?.headquarter;
  const website = organization?.website;

  const companyMenu = [
    {
      name: "Visit website",
      icon: "fa-regular fa-arrow-up-right-from-square",
      //   link: "/edit-company",
    },
    {
      name: "Send in a message",
      icon: "fa-solid fa-paper-plane",
      //   click: () => console.log("Share clicked"),
    },
  ];

  const tabs = useMemo(
    () => [
      {
        label: "Home",
        key: "home",
        content: <CompanyHomeTab organization={organization} />,
      },
      {
        label: "About",
        key: "about",
        content: <CompanyAboutTab slug={organization?.slug} />,
      },
      {
        label: "Jobs",
        key: "jobs",
        content: <CompanyJobsTab slug={organization?.slug} />,
      },
    ],
    [organization],
  );

  const { selectedIndex, handleTabChange, validTab } = useTabQuery(tabs);

  if (!validTab) {
    return <NotFoundPage link="/admin/payments?tab=subscriptions" />;
  }


  return (
    <>
      <div className="bg-white rounded-t-xl shadow-sm overflow-hidden">
        <div className="relative">
          <img
            src={coverImage}
            alt="banner"
            className="w-full h-40 object-cover"
          />


          <div className="absolute -bottom-12 left-8">
            <div className="w-28 h-28 bg-white border-4 border-white rounded">
              <img
                src={logo}
                alt={companyName}
                className="w-full h-full object-contain rounded shadow-sm"
              />
              {/* <Indentification
                image={logo}
                alt={companyName}
                size="xl3"
                className="!shadow-[0_0_8px_rgba(0,0,0,0.12)]"
                fill={false}
              /> */}
            </div>
          </div>
        </div>

        <div className="pt-16 px-3 md:px-6 pb-6 border border-b-0">
          <div className="flex items-center gap-2">
            <h2 className="text-lg md:text-xl font-semibold text-gray-900 tracking-tight">
              {" "}
              {companyName}
            </h2>
          </div>

          <p className="text-sm md:text-[15px] text-gray-600 font-medium leading-relaxed">
            {description}
          </p>
          <p className="text-gray-500 text-sm mt-1">
            Founded {new Date(createdAt).getFullYear()}
          </p>
          <p className="text-sm text-gray-500 font-sans">
            {[
              industry,
              headquarter,
              employeeCount && `${employeeCount} employees`,
            ]
              .filter(Boolean)
              .join(" · ")}
          </p>

          {/* <div className="flex items-center gap-2 mt-3 text-sm text-gray-600">
          <img
            src="https://randomuser.me/api/portraits/men/32.jpg"
            alt=""
            className="w-6 h-6 rounded-full"
          />
          <span>Purnendu & 1 other connection follow this page</span>
        </div> */}

          <div className="flex items-center gap-3 mt-5">
            <Button
              buttonLabel="Visit Website"
              buttonHasLink
              buttonLink={website}
              target="_blank"
              buttonIcon={"fa-regular fa-arrow-up-right-from-square"}
              buttonIconPosition="left"
              buttonClasses="bg-white text-palatte hover:bg-transparent hover:text-white border border-white px-4 h-9 rounded-full border-palatte hover:bg-palatte font-medium text-xs md:text-sm"
              buttonLabelClasses="font-semibold text-xs md:text-sm "
            />
            <Button
              buttonLabel="Message"
              buttonHasLink
              buttonIcon={"fa-solid fa-paper-plane"}
              buttonIconPosition="left"
              buttonClasses="bg-white text-palatte hover:bg-transparent hover:text-white border border-white px-4 h-9 rounded-full border-palatte hover:bg-palatte font-medium text-xs md:text-sm"
              buttonLabelClasses="font-semibold text-xs md:text-sm "
            />

            {/* <Dropdown
              data={companyMenu}
              xPlacement="bottomRight"
              buttonClasses="p-0 border-0"
              dropdownContainer="w-52"
              button={
                <div className="w-9 h-9 flex items-center justify-center rounded-full border border-gray-700 text-gray-700 hover:bg-gray-100 cursor-pointer">
                  <i className="fa-regular fa-arrow-up-right-from-square"></i>
                </div>
              }
            /> */}
          </div>
        </div>
      </div>
      <div className="">
        <Tabs
          items={tabs}
          selectedIndex={selectedIndex}
          setSelectedIndex={handleTabChange}
          tabsClass="gap-10 border-t border-gray-200 pt-2 px-6  w-full bg-white rounded-b-xl before:border-b-0 border"
          underLineClass="h-[1.5px] -left-5 -right-5 w-auto"

        //   tabcontentBody="mt-0"
        />
      </div>
    </>
  );
};

export default CompanyTotalDetails;
